import { makeRequest } from './make-request.api'


export const getMeRequest = () => {
  return makeRequest('/me')
}